export const normalizeString = (str: string): string => {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};

/**
 * Collapse an empty/absent/whitespace-only string to `undefined` so it is dropped from a JSON payload
 * (equivalent to the field being absent on the wire) rather than sent as a blank/whitespace string, and
 * trim the surrounding whitespace off any value that survives. Single source of truth for the
 * blank-normalisation rule shared by the catalogue form-value mappers — a value of `'   '` must not reach
 * storage as literal spaces.
 */
export const emptyToUndefined = (value: string | undefined): string | undefined => {
  const trimmed = value?.trim();
  return trimmed !== undefined && trimmed !== '' ? trimmed : undefined;
};
